<template>
  <div>
    <el-card style="margin-bottom: 10px;">
      <el-form
        ref="queryFormRef"
        :model="queryForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <!-- 姓名： -->
            <el-form-item :label="$t('collectionCenter.compellation')">
              <el-input
                v-model.trim="queryForm.params.realName"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- cpf -->
            <el-form-item label="CPF">
              <el-input
                v-model.trim="queryForm.params.cpf"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 登录账号： -->
            <el-form-item :label="$t('userManage.LoginAccount')">
              <el-input
                v-model.trim="queryForm.params.username"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 状态： -->
            <el-form-item :label="$t('userManage.state')" prop="status">
              <el-select v-model="queryForm.params.status" style="width: 100%" :placeholder="$t('userManage.all')">
                <!--有效-->
                <el-option key="1" :label="$t('userManage.effective')" :value="1" />
                <!--已到期-->
                <el-option key="2" :label="$t('userManage.expired')" :value="2" />
                <!--已停用-->
                <el-option key="3" :label="$t('collectionCenter.Disabled')" :value="3" />
                <!--即将到期-->
                <el-option key="4" :label="$t('userManage.expiringSoon')" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 所属转运中心： -->
            <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
              <ElSelectV2
                v-model="queryForm.params.siteId"
                :options="siteIdList"
                :placeholder="$t('userManage.all')"
                filterable
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <!-- 查询 -->
              <el-button
                icon="el-icon-search"
                size="small"
                type="primary"
                @click="search"
              >{{ $t('userManage.search') }}
              </el-button>

              <!-- 重置 -->
              <el-button
                icon="el-icon-refresh"
                size="small"
                @click="queryFormReset"
              >{{ $t('userManage.reset') }}
              </el-button>
              <!-- 新建临时工账号 -->
              <el-button
                v-permit:remove="'btn:user-center:temporaryWorkerAccount:created'"
                icon="el-icon-plus"
                size="small"
                type="primary"
                @click="createAccount"
              >{{ $t('userManage.CreateNewTemporaryWorkerAccount') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <tableColumn
        :key="tableDataKey"
        :table-data="tableData"
        @viewDetailData="viewDetailData"
        @openResetPassword="openResetPassword"
        @getTableData="getTableData"
        @openReapplyAccount="openReapplyAccount"
      />
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="currentChange"
          @size-change="sizeChange"
        />
      </div>
    </el-card>
    <!--创建账号-->
    <el-drawer
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :with-header="false"
      :visible.sync="showVisibleCreateWindow"
      class="drawerClass"
      direction="ltr"
      size="100%"
    >
      <createAccount :key="createAccountKey" :site-id-list="siteIdList" @closeWindow="closeWindow" />
    </el-drawer>
    <!--查看详情-->
    <el-dialog
      :title="$t('userManage.ViewTemporaryWorkerAccount')"
      :visible.sync="showViewAccountWindow"
      width="800px"
      :append-to-body="true"
      top="3%"
    >
      <div>
        <viewDetailCon :key="viewAccountKey" :account-detail="accountDetail" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showViewAccountWindow = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="openResetPassword(accountDetail)">{{ $t('userManage.resetPassword') }}</el-button>
      </div>
    </el-dialog>
    <!--确认重置密码-->
    <el-dialog
      :title="$t('userManage.ResetTemporaryWorkerAccountPassword')"
      :visible.sync="showConfirmResetPasswordTips"
      width="800px"
      :append-to-body="true"
    >
      <div>
        <resetPasswordCon
          ref="resetPasswordRef"
          :key="viewResPasswordKey"
          :account-detail="accountDetail"
          @closeWindow="closeWindow"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showConfirmResetPasswordTips = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="confirmResetPassword">{{ $t('userManage.ConfirmReset') }}</el-button>
      </div>
    </el-dialog>
    <!--重新申请账号-->
    <el-drawer
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :with-header="false"
      :visible.sync="reapplyAccountWindow"
      class="drawerClass"
      direction="ltr"
      size="100%"
    >
      <reapplyAccount :key="reapplyAccountKey" :account-detail="accountDetail" @closeWindow="closeWindow" />
    </el-drawer>
  </div>
</template>
<script>
import { getSiteStatusPart } from '@/api/lanshou';
import ElSelectV2 from 'el-select-v2';
import createAccount from './cmp/createAccount.vue';
import tableColumn from './cmp/tableColumn.vue';
import viewDetailCon from './cmp/viewDetail.vue';
import resetPasswordCon from './cmp/resetPassword.vue';
import reapplyAccount from './cmp/reapplyAccount.vue';
import { getFreelancerPageApi } from '@/api/user';

export default {
  name: 'TemporaryWorkerAccount',
  components: {
    ElSelectV2,
    createAccount,
    tableColumn,
    viewDetailCon,
    resetPasswordCon,
    reapplyAccount
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          realName: null,
          cpf: null,
          username: null,
          status: null,
          siteId: null
        }
      },
      total: 0,
      siteIdList: [],
      tableData: [],
      showVisibleCreateWindow: false,
      createAccountKey: new Date().getTime(),
      tableDataKey: new Date().getTime(),
      showViewAccountWindow: false,
      viewAccountKey: new Date().getTime(),
      accountDetail: null,
      showConfirmResetPasswordTips: false,
      viewResPasswordKey: new Date().getTime(),
      reapplyAccountWindow: false,
      reapplyAccountKey: new Date().getTime()
    };
  },
  created() {
    this.$nextTick(() => {
      this.getDepartment();
      this.search();
    });
  },
  methods: {
    // 转运中心
    getDepartment() {
      getSiteStatusPart().then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              this.siteIdList.push({
                label: item.name,
                value: item.id
              });
            });
          }
        }
      });
    },
    // 搜索
    search() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 重置
    queryFormReset() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params.realName = null;
      this.queryForm.params.cpf = null;
      this.queryForm.params.username = null;
      this.queryForm.params.status = null;
      this.queryForm.params.siteId = null;
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      getFreelancerPageApi(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records.map(item => {
            const validityDays = Math.floor(((new Date(item.expireAt).getTime()) - (new Date(item.validFrom).getTime())) / 86400000);
            return {
              ...item,
              validityDays: validityDays
            };
          });
          this.total = res.data.total;
        }
      });
    },
    // 新建账号
    createAccount() {
      this.showVisibleCreateWindow = true;
      this.createAccountKey = new Date().getTime();
    },
    // 关闭新建账号弹窗
    closeWindow(type) {
      if (type) {
        this.getTableData();
      }
      this.reapplyAccountWindow = false;
      this.showVisibleCreateWindow = false;
      this.showConfirmResetPasswordTips = false;
      this.showViewAccountWindow = false;
    },
    // 翻页
    currentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    },
    // 每页显示数量更换
    sizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 查看详情
    viewDetailData(data) {
      this.accountDetail = data;
      this.viewAccountKey = new Date().getTime();
      this.showViewAccountWindow = true;
    },
    // 重置密码
    openResetPassword(data) {
      this.accountDetail = data;
      this.showConfirmResetPasswordTips = true;
      this.viewResPasswordKey = new Date().getTime();
    },
    // 确认重置密码
    confirmResetPassword() {
      this.$refs.resetPasswordRef.confirmResetPassword();
    },
    // 打开重新申请弹窗
    openReapplyAccount(data) {
      this.accountDetail = data;
      this.reapplyAccountWindow = true;
      this.reapplyAccountKey = new Date().getTime();
    }
  }
};
</script>

<style scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
